"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CustomReviewImageGallery", {
  enumerable: true,
  get: function () {
    return _CustomReviewImageGallery.CustomReviewImageGallery;
  }
});
var _CustomReviewImageGallery = require("./CustomReviewImageGallery");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfQ3VzdG9tUmV2aWV3SW1hZ2VHYWxsZXJ5IiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Jldmlld0ltYWdlR2FsbGVyeS9DdXN0b21SZXZpZXdJbWFnZUdhbGxlcnkvaW5kZXgudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEN1c3RvbVJldmlld0ltYWdlR2FsbGVyeSB9IGZyb20gXCIuL0N1c3RvbVJldmlld0ltYWdlR2FsbGVyeVwiXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsSUFBQUEseUJBQUEsR0FBQUMsT0FBQSIsImlnbm9yZUxpc3QiOltdfQ==